var InsightLogger = (function () {

    var logInsight = function (actionName, attributes) {
        if (window.NREUM && window.NREUM.addPageAction) {
            window.NREUM.addPageAction('APAC_' + actionName, attributes);
        }
    };

    var loggerFactory = function(opts, isMobile) { // opts.summary, opts.actionName
        return function (action) {
            logInsight(opts && opts.actionName || 'unknown',
                {
                    isMobile: isMobile,
                    cookieV: app && app.cookie && app.cookie.get('v'),
                    summaryTotal: opts && opts.summary && opts.summary.get('Total'),
                    summaryTotalWithSelect: opts && opts.summary && opts.summary.get('TotalWithSelect'),
                    summaryDelivery: opts && opts.summary && opts.summary.get('Delivery'),
                    action: action || null
                });
        };
    };

    var beforePayLogger = function(summary, isMobile) {
        return loggerFactory({
            actionName: 'BeforePay',
            summary: summary
        }, isMobile);
    }

    var payButtonsClickLogger = function(summary, isMobile) {
        return loggerFactory({
            actionName: 'PayButtonClick',
            summary: summary
        }, isMobile);
    }

    return {
        beforePayLogger: beforePayLogger,
        payButtonsClickLogger: payButtonsClickLogger,
        actions: {
            payWithNewPayPal: 'pay with new PayPal method',
            payWithPayPal: 'pay with PayPal method',
            payWithNewCreditCard: 'pay with new CreditCard method',
            payWithCreditCard: 'pay with CreditCard method',
            payOnInitialScreen: 'pay on initial screen'
        },
        createLogger: function(logger, action) {
            return function() {
                if (logger) {
                    logger(action);
                }
            }
        }
    }

})();